/**
 * Brand palette + reusable gradients for the public mock test surface
 * (book list, book detail, history panel). Soft lavender — distinct from
 * the authenticated exam screens.
 */
export const BRAND_GRADIENT =
  "linear-gradient(135deg, #8b5cf6 0%, #a78bfa 50%, #c4b5fd 100%)";
export const BRAND_GRADIENT_SOFT =
  "linear-gradient(135deg, #a78bfa 0%, #c4b5fd 50%, #ddd6fe 100%)";
export const BRAND_PRIMARY = "#7c3aed";
export const BRAND_TINT_BORDER = "rgba(139,92,246,0.20)";
export const BRAND_TINT_BG = "rgba(139,92,246,0.08)";

/** Sentinel "book id" used in the URL for the bucket of exams with no book. */
export const UNCATEGORISED = "__uncategorised__";
